import React from "react";
import { FormControl, Select, MenuItem, Box } from "@mui/material";

const SelectField = ({ label, value, onChange, options, disabled = false }) => {
  return (
    <Box sx={{
      display: "flex",
      alignItems: "center",
      marginBottom: "16px",
      gap: "16px"
    }}>
      <Box sx={{
        minWidth: "250px",
        fontSize: "14px",
        fontWeight: 500,
        color: "#1A1E24"
      }}>
        {label}
      </Box>
      <FormControl size="small" fullWidth disabled={disabled}>
        <Select
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          displayEmpty
          sx={{
            fontSize: "14px",
            "& fieldset": {
              borderColor: "#e0e0e0",
            },
            "&:hover fieldset": {
              borderColor: "#1976d2",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#1976d2",
            },
          }}
        >
          <MenuItem value="">
            <em>Не выбрано</em>
          </MenuItem>
          {options.map((option, index) => (
            <MenuItem key={index} value={option}>
              {option}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default SelectField;
